//claimPostingDetails.ts
export const claimPostingDetails = {
  patientName: 'John Doe',
  payerCarrier: 'Blue Cross',
  subscriber: 'Jane Doe',
  provider: 'Dr. Kris Jones',
  entityType: 'Individual',
  claimId: 'BD004157542',
  claimStatus: 'Approved',
  submittedAmount: '$300.00',
  itemType: 'Claim',
  dateSent: '12/05/2024',
  checkNo: 'BD004157542',
  checkStatus: 'Processing',
  paidAmount: 'N/A',
  modeOfPayment: 'Wire',
  paymentDate: 'N/A',
}
